module.exports = __webpack_public_path__ + "img/puzzle_17.baca1eb7.png";